import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Messages } from '~src/codegen/Localize';

export function AuthenticationCloseButton() {
    const history = useHistory();
    return <>
        <ButtonWidget
            type="button"
            buttonType={ButtonType.Outline}
            onClick={history.goBack}
            testId={'close-button'}
        >{Messages.close()}</ButtonWidget>
    </>;
}